/**
 * @desc
 * -
 */
;(function () {
  angular
    .module('contrast.protection.coverage')
    .directive('csProtectionCoverage', [csProtectionCoverage])

  function csProtectionCoverage() {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      templateUrl: 'views/common/cs-protection-coverage.html',
      controller: 'csProtectionCoverageCtrl',
      controllerAs: 'protectionCoverageCtrl',
      bindToController: {
        linkText: '@'
      }
    }
  }
})()
